<template>
  <div class="form-container" :class="{ isMobile: isMobile }">
    <div class="auth-form">
      <h1 class="auth-title mb-5">Zmień hasło</h1>
      <div v-if="showSuccessText" class="color-primary-purple">
        <v-alert
          text
          outlined
          :type="'success'"
          icon="mdi-check"
          elevation="2"
          class="mb-4"
        >
          Hasło zostało zmienione
        </v-alert>
        <div class="actions">
          <v-btn
            :to="{ name: 'Login' }"
            title="Wróć na stronę logowania"
            rounded
            large
            color="primary"
            elevation="0"
            class="mt-8"
          >
            Przejdź na stronę logowania
          </v-btn>
        </div>
      </div>
      <div v-else>
        <LoginAlerts
          :show="message.show"
          :type="message.color"
          :msg="message.msg"
          @close="message.show = false"
          dismissible
        />
        <v-form @submit.prevent>
          <validation-observer ref="observer" v-slot="{}">
            <ValidationProvider
              v-slot="{ errors }"
              :rules="passwordRules"
              name="Nowe hasło"
            >
              <v-text-field
                v-model="password"
                :append-icon="e1 ? 'mdi-eye-off' : 'mdi-eye'"
                @click:append="() => (e1 = !e1)"
                :type="e1 ? 'password' : 'text'"
                label="Hasło"
                :error-messages="errors"
                placeholder="Wpisz nowe hasło"
                outlined
                persistent-placeholder
                class="mb-1"
              />
            </ValidationProvider>

            <ValidationProvider
              name="Powtórz hasło"
              rules="required"
              v-slot="{ failed }"
            >
              <v-text-field
                v-model="repeatPassword"
                :append-icon="e2 ? 'mdi-eye-off' : 'mdi-eye'"
                @click:append="() => (e2 = !e2)"
                :type="e2 ? 'password' : 'text'"
                label="Powtórz hasło"
                :error="failed"
                placeholder="Powtórz hasło"
                outlined
                persistent-placeholder
                class="mb-1"
              />
            </ValidationProvider>
            <div class="actions">
              <LibBtnSimple
                color="primary"
                underline
                rounded
                text="Anuluj i wróć do logowania"
                title="Kliknij, aby zalogować się do Elektronicznego Dziennika Budowy"
                :to="{ name: 'Login' }"
              />

              <v-btn
                @click="resetPassword"
                elevation="0"
                class="mt-1"
                title="Zmień hasło"
                color="primary"
                rounded
                large
              >
                Zapisz nowe hasło
              </v-btn>
            </div>
          </validation-observer>
        </v-form>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import LoginAlerts from '../components/LoginAlerts.vue';
import LibBtnSimple from '@/components/library/common/LibBtnSimple.vue';
import {
  extend,
  setInteractionMode,
  ValidationObserver,
  ValidationProvider
} from 'vee-validate';
import { regex, required } from 'vee-validate/dist/rules';
setInteractionMode('lazy');
extend('required', required);
extend('password', {
  params: ['target'],
  validate(value, { target }) {
    return value === target;
  },
  message: "Hasła muszą być identyczne",
});

export default {
  name: 'resetpaswd',
  components: {
    ValidationObserver,
    ValidationProvider,
    LoginAlerts,
    LibBtnSimple
  },
  props: {
    h: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      password: '',
      repeatPassword: '',
      e1: true,
      e2: true,
      error: null,
      passwordRulesBase: {
        required: true,
        password: { target: '@Powtórz hasło' }
      },
      message: {
        show: false,
        color: 'error',
        msg: '',
        timeout: 0,
        closeAction: () => {}
      }
    };
  },
  computed: {
    showSuccessText() {
      return this.message.color === 'success';
    },
    passwordRules() {
      let param = this.$store.getters['conf/getConfigurationParam'](
        'password.strength'
      );
      if (param) {
        extend("regex", {
          ...regex,
          message: param.description,
        });
        return Object.assign({}, this.passwordRulesBase, {
          regex: param.value,
        });
      }
      return this.passwordRulesBase;
    }
  },

  methods: {
    resetPassword() {
      this.$refs.observer.validate().then(result => {
        if (result) {
          axios
            .post(`${process.env.VUE_APP_AUTH_REST_URL}/password/change`, {
              hash: this.h,
              password: this.password
            })
            .then(({ data }) => {
              if (data.success) {
                this.message.msg = 'Hasło zostało zmienione';
                this.message.color = 'success';
                this.message.show = true;
                this.message.closeAction = () => {
                  window.location.replace('/');
                };
              } else {
                this.message.msg = data.errorMessage;
                this.message.color = 'error';
                this.message.show = true;
                this.message.closeAction = () => {
                  this.message.show = false;
                };
              }
            })
            .catch(err => {
              this.message.msg = 'Błąd zmiany hasła. Spróbuj później.';
              this.message.color = 'error';
              this.message.show = true;
              this.message.closeAction = () => {
                this.message.show = false;
              };
            });
        }
      });
    }
  },
  created() {
    this.$store.dispatch('conf/load', ['password.strength']);
  },
  metaInfo: {
    title: 'Zmiana hasła'
  }
};
</script>
